import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * PD-2014 — whether ICD-10-CM codes may go on a claim on a visit date (the CMS code set of
 * that fiscal year), and for a category code the billable codes under it. The billing
 * editor marks and replaces non-billable rows with this; save and Submit refuse them.
 * `checked: false` means that year has no CMS code file, so nothing could be checked; a visit
 * before the earliest file is not checked at all and answers `checked: true` with no codes.
 */
export const billingIcd10Billability = oc
  .route({ method: 'POST', path: '/v2/billing/icd10-billability' })
  .input(
    z.object({
      codes: z.array(z.string().trim().min(1)).min(1).max(50),
      /** The visit's date of service (`Encounter.period.start`); defaults to today. */
      dateOfService: z
        .string()
        .refine((value) => !Number.isNaN(Date.parse(value)), 'Invalid date of service')
        .optional(),
    }),
  )
  .output(
    z.object({
      checked: z.boolean(),
      codes: z.array(
        z.object({
          code: z.string(),
          billable: z.boolean(),
          children: z.array(z.object({ code: z.string(), display: z.string() })),
        }),
      ),
    }),
  )
